import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const InternalGroups = lazy(() =>
  import("@scenes/InternalGroupsList/components/InternalUserGroups").then((module) => ({
    default: module.InternalUserGroupsForNro,
  }))
);

export const internalGroupsNRO: NavigationRoutingObject = {
  section: "settings",
  Component: InternalGroups,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("internal-groups-log-sidebar-pill-menu-option", "Internal Groups"),
  getDeveloperNavigationAllowed: () => true,
  featureLimitationKeys: ["can_only_view_gated_feature"],
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("internal-groups-alt-keyword-1", "user groups"),
        t("internal-groups-alt-keyword-2", "user event groups"),
        t("internal-groups-alt-keyword-3", "content test groups"),
        t("internal-groups-alt-keyword-4", "seed groups"),
        t("internal-groups-alt-keyword-5", "test users"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  shouldShowTertiaryNavigationCallback: (permissionContext) => {
    return permissionContext.hasPermission("appGroup", { permission: "viewInternalUserGroups" });
  },
};
